import React from 'react'
import ReorderList from "../../../../core/gd-ui/sortable-list-4/reorder-list"
import NavigationMenu_ItemProjectWithReorder from "../../menu-items/project/menu-item-project-with-reorder"
import {ProjectsTreeSortType} from "../../components/space-preferences/preferences"
import NavigationMenu_ProjectsLocalSettings from "../../local-settings";
import ProjectSession from "../../../../core/model2/project/project-session";
import {SortDirection} from "../../../../core/data-structures/sort";
import {SpaceProto} from "../../../../core/model2/space/space-proto";

type Props = {
    level           : number
    parentId        : string
    projects        : ProjectSession[]
    localSettings   : NavigationMenu_ProjectsLocalSettings
    space               : SpaceProto
}

// const debug = "ProjectsReorderList"
const debug = false

export default class ProjectsReorderList extends React.Component<Props> {

    onReorderEnd = (items: any[]) => {
        const values = _.map(items, item=>item.id)

        debug && console.log(debug, 'onReorderEnd', this.props.parentId, values)

        gd.user.menu.projectsAll.sortedMap[this.props.parentId] = values
        gd.user.menu.save()
    }

    render() {
        debug && console.log(debug, 'render() localSettings=', this.props.localSettings)

        let reorderDisabled : boolean = false
        let projects : ProjectSession[] = []

        let sortBy : ProjectsTreeSortType = this.props.space.projectsSorting

        // patch - Customer portal always sort by sortPosition/manually
        if (gd.user.acl.isClient) {
            sortBy = ProjectsTreeSortType.MANUAL
        }

        switch (sortBy) {
            case ProjectsTreeSortType.ALPHABETICAL  :

                debug && console.log(debug, ' sort A-Z')

                // projects        = this.props.projects // _.orderBy(this.props.projects, project=>project.name, 'asc')
                projects        = _.orderBy(this.props.projects, (project)=>{
                    return project.name.toLowerCase()   // yes to lower
                }, SortDirection.ASC)
                reorderDisabled = true
                break

            case ProjectsTreeSortType.MANUAL       :
            default                                 :
                projects = _.orderBy(this.props.projects, [
                    project => {
                        const index = _.indexOf(gd.user.menu.projectsAll.sortedMap[this.props.parentId], project.id)
                        if (index === -1) return this.props.projects.length
                        return index
                    },
                    project => project.sortPosition,
                    project => project.name
                ], ['asc', 'asc', 'asc'])
                break
        }

        debug && console.log(debug, '    projects=', projects)

        const components = _(projects)
            .filter((project: ProjectSession) => {
                return !project.isArchived
            })
            .map(project=>{
                // if no access and no child project that requires to show all parents then skip this project
                if (!project.access && !project.treeChildren) return null

                return {
                    item        : project,
                    component   : <NavigationMenu_ItemProjectWithReorder level                          = {this.props.level}
                                                                         project                        = {project}
                                                                         space                          = {this.props.space}
                                                                         localSettings                  = {this.props.localSettings}
                                                                         expandedProjectsSettingName    = "expandedProjects"/>
                }
            })
            .compact()
            .value()

        return <ReorderList key         = {'{0}_{1}'.f(this.props.space.projectsSorting, components.length)}
                            items       = {components}
                            keyFunction = {(item:any)=>item.id}
                            disabled    = {reorderDisabled}
                            onReorder   = {this.onReorderEnd}/>
    }
}
